import type { sellerCustomerCareAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../components/Filters/Filters.translations'

export function useTypeOptions(): Array<sellerCustomerCareAPI.FilterOptionItem> {
  const i18n = useI18n()

  return [
    {
      label: i18n(translations.taskFilterSendMessageOption),
      value: 'SEND_MESSAGE',
    },
    {
      label: i18n(translations.taskFilterUploadReceiptOption),
      value: 'UPLOAD_RECEIPT',
    },
    {
      label: i18n(translations.taskFilterRepairReplaceOption),
      value: 'REPAIR_REPLACE',
    },
    {
      label: i18n(translations.taskFilterRepairOption),
      value: 'REPAIR',
    },
    {
      label: i18n(translations.taskFilterReplaceOption),
      value: 'REPLACE',
    },
    {
      label: i18n(translations.taskFilterRefundOption),
      value: 'REFUND',
    },
    {
      label: i18n(translations.taskFilterReturnToCustomerOption),
      value: 'RETURN_TO_CUSTOMER',
    },
  ]
}
